import * as React from 'react';

import TextWithIcon from 'components/TextWithIcon';
import Link from 'components/Link';

import { CoachingBillingDeclinedInfoType } from './types';
import 'coaching/components/styles/CoachingBillingDetailDeclinedCard.scss';

type Props = {
  detail?: CoachingBillingDeclinedInfoType;
  onRetryPaymentMethod?: () => void;
};

export default function CoachingBillingDetailDeclinedCard({ detail, onRetryPaymentMethod }: Props) {
  if (!detail) return null;
  const { numPaymentsDeclined = 0, amountDeclined = 0 } = detail || {};
  const paymentText = numPaymentsDeclined > 1 ? 'payments' : 'payment';
  return (
    <TextWithIcon
      data-test="coaching-billing-declined-detail"
      className="CoachingBillingDetailDeclinedCard"
      icon="warning"
      iconSize="large"
      center={true}
      inline={true}
      size="small">
      <div className="CoachingBillingDetailDeclinedCardInfo">
        <span className="CoachingBillingDetailDeclinedCardInfo--declined">
          {numPaymentsDeclined} declined {paymentText} for {`$${amountDeclined}`}
        </span>
        <Link
          className="CoachingBillingDetailDeclinedCardInfo--action"
          color="inherit"
          weight="semibold"
          onClick={onRetryPaymentMethod}>
          Retry card
        </Link>
      </div>
    </TextWithIcon>
  );
}
